











import Vue from 'vue';
import store from './store';
import $ from 'jquery';

export default Vue.extend({
    computed: {
        pages() {
            return store.state.pages;
        },
        ajaxModal() {
            return store.state.ajaxModal;
        },
    },
    watch: {
        ajaxModal(newValue) {
            $('#ajaxModal').modal(newValue ? 'show' : 'hide');
        },
    },
});
